import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertBell16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.99984 0.250061C5.10034 0.250061 2.74984 2.60057 2.74984 5.50006V7.2182C2.74984 8.32561 2.12907 9.12879 1.51899 9.98289C0.691657 11.1412 1.51963 12.7501 2.94303 12.7501H5.25C5.25 14.3327 6.30845 15.75 8 15.75C9.69155 15.75 10.75 14.3327 10.75 12.7501H13.0566C14.4801 12.7501 15.308 11.1412 14.4807 9.98289C13.8706 9.12879 13.2498 8.32561 13.2498 7.2182V5.50006C13.2498 2.60057 10.8993 0.250061 7.99984 0.250061ZM9.25 12.7501H6.75C6.75 13.5086 7.13164 14.25 8 14.25C8.86836 14.25 9.25 13.5086 9.25 12.7501ZM4.24984 5.50006C4.24984 3.42899 5.92877 1.75006 7.99984 1.75006C10.0709 1.75006 11.7498 3.42899 11.7498 5.50006V7.2182C11.7498 8.65693 12.4624 9.738 13.2601 10.8548C13.3783 11.0202 13.26 11.2501 13.0566 11.2501H2.94303C2.73968 11.2501 2.6214 11.0202 2.73959 10.8548C3.53727 9.738 4.24984 8.65693 4.24984 7.2182V5.50006Z'
      fill='currentColor'
    />
  </Svg>
);

AlertBell16.displayName = 'AlertBell16';
export default AlertBell16;
